import React from 'react';
import { ExpandableTable, Table, useTheme } from '@hmsexp/component-library';
import { tableStyles } from '../Table/styles';
import { View } from '../react-native-components';
import get from 'lodash/get';
import GraphTableCell from './GraphTableCell';

const GraphTable = ({ graph_table_data, lowSampleSize, ...props }) => {
  const { expendable = false } = props;
  const theme = useTheme();
  const styles = tableStyles(theme);
  const table_data = get(graph_table_data, 'table_data', {});
  const rowData = get(table_data, 'table_rows', []);
  const sortColumns = get(table_data, 'sortColumns', []);
  const sample_size_data = get(table_data, 'table_count', []);

  const tableColumns = get(table_data, 'table_columns', []).map((column, index) => ({
    ...column,
    Cell: props => <GraphTableCell  {...props} sample_size_data={sample_size_data} lowSampleSize={lowSampleSize} index={index} sortColumns={sortColumns} />
  }));

  return (
    <View style={styles.container}>
      <ExpandableTable
        hasNestedData={true}
        showTitleBar={false}
        isRowsScrollable={false}
        nestedKey='nested_rows'
        columns={tableColumns}
        data={rowData}
        collapsibleIconsDirection='left'
        showsHorizontalScrollIndicator={true}
        style={{
          container: styles.tableContainer,
          rowContainer: styles.rowContainer,
          headerContainer: styles.headerContainer,
          lastRowStyle: styles.lastRowStyle
        }}
      />
    </View>
  );
};

export default GraphTable;
